const HOST_PATTERN =
  '(?:\\*\\.)?(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*|localhost|\\d{1,3}(?:\\.\\d{1,3}){3})';

const ORIGIN_RE = new RegExp(`^https?://${HOST_PATTERN}(?::\\d{1,5})?/?$`, 'i');

/**
 * Allowed origin entries accepted by ApiKeyGuard:
 *   - "*" (allow-any, insecure)
 *   - "http(s)://host[:port]"
 *   - "http(s)://*.domain[:port]"
 *
 * Plain hostnames or host:port without scheme are rejected — the guard
 * compares the scheme-stripped host against the Origin header which always
 * carries a scheme, so bare values silently fail to match.
 */
export const isValidOrigin = (value: string): boolean => {
  const trimmed = value?.trim();
  if (!trimmed) return false;
  if (trimmed === '*') return true;
  return ORIGIN_RE.test(trimmed);
};
